import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

// import uuidv4 from uuid library
const { v4: uuidv4 } = require('uuid');

const Formulario = ({ crearCita }) => {
  // state de citas
  const [cita, actualizarCita] = useState({
    mascota: '',
    duenio: '',
    fecha: '',
    hora: '',
    sintomas: '',
  });

  // state de error
  const [error, actualizarError] = useState(false);

  // Funcion que captura lo que el usuario ingresa por pantalla y lo pone en el state
  const actualizarState = (e) => {
    actualizarCita({
      ...cita,
      [e.target.name]: e.target.value,
    });
  };

  // Extraer valores de state
  const { mascota, duenio, fecha, hora, sintomas } = cita;

  //cuando el usaurio pulsa agregar cta
  const onSubmit = (e) => {
    e.preventDefault();
    console.log('Enviando form');

    //validar
    if (
      mascota.trim() === '' ||
      duenio.trim() === '' ||
      fecha.trim() === '' ||
      hora.trim() === '' ||
      sintomas.trim() === ''
    ) {
      actualizarError(true);
      return;
    }

    //Cambio de estado de state de error
    actualizarError(false);

    //Asignar un ID
    cita.id = uuidv4();
    console.log(cita);

    //Crear la cita
    crearCita(cita);

    // Reiniciar el form
    actualizarCita({
      mascota: '',
      duenio: '',
      fecha: '',
      hora: '',
      sintomas: '',
    });
  };

  return (
    <Fragment>
      <h2>Crear cita</h2>

      {error ? (
        <p className='alerta-error'>Todos los campos son obligatorios</p>
      ) : null}

      <form onSubmit={onSubmit}>
        <label>Nombe mascota</label>
        <input
          type='text'
          name='mascota'
          className='u-full-width'
          placeholder='Nombre de mascota'
          onChange={actualizarState}
          value={mascota}
        />
        <label>Nombre de duenio</label>
        <input
          type='text'
          name='duenio'
          className='u-full-width'
          placeholder='Nombre de duenio de mascota'
          onChange={actualizarState}
          value={duenio}
        />
        <label>Fecha</label>
        <input
          type='date'
          name='fecha'
          className='u-full-width'
          onChange={actualizarState}
          value={fecha}
        />
        <label>Hora</label>
        <input
          type='time'
          name='hora'
          className='u-full-width'
          onChange={actualizarState}
          value={hora}
        />
        <label>Sintomas</label>
        <textarea
          name='sintomas'
          className='u-full-width'
          placeholder='sintomas de la mascota'
          onChange={actualizarState}
          value={sintomas}
        ></textarea>
        <button type='submit' className='u-full-width button-primary'>
          AGREGAR CITA
        </button>
      </form>
    </Fragment>
  );
};

Formulario.propTypes = {
  crearCita: PropTypes.func.isRequired,
};

export default Formulario;
